import { FlowContext, FlowNode, NodeId } from './Types/Types';

export const FLOW_START_NODE: NodeId = 'hasRack';
export const getFlowNode = (nodeId: NodeId): FlowNode => FLOW_NODES[nodeId];

const getYesNoOptions = (ctx: FlowContext) => [
  { value: 'yes', label: ctx.translations?.yes ?? '' },
  { value: 'no', label: ctx.translations?.no ?? '' },
];

export const FLOW_NODES: Record<NodeId, FlowNode> = {
  hasRack: {
    id: 'hasRack',
    kind: 'choice',
    answerKey: 'rack',
    cmsParameter: 'hasRack',
    getOptions: (ctx) => getYesNoOptions(ctx),
    getNext: (_, selected) => {
      return selected === 'yes' ? 'tubeSize' : 'buyRack';
    },
  },
  tubeSize: {
    id: 'tubeSize',
    kind: 'choice',
    answerKey: 'tubeSize',
    cmsParameter: 'rackTubeSize',
    getOptions: (ctx) => getYesNoOptions(ctx),
    getNext: (_, selected) => {
      return selected === 'yes' ? 'buyPanel' : 'nofit';
    },
  },
  buyRack: {
    id: 'buyRack',
    kind: 'product',
    cmsParameter: 'buyRack',
  },
  buyPanel: {
    id: 'buyPanel',
    kind: 'product',
    cmsParameter: 'buyPanel',
  },
  nofit: {
    id: 'nofit',
    kind: 'result',
    cmsParameter: 'nofit',
  },
};
